<div class="details-title-wrapper">
  <div class="details-title-icon-wrapper">
    <ng-content select="itl-detail-title-icon"></ng-content>
    <ng-content select="itl-detail-title-therapy-icon"></ng-content>
  </div>
  <div class="details-title-content">
    <ng-content></ng-content>
  </div>
</div>
